import React from 'react'

import * as numberLib from '../../../lib/number'

/**
 * Use this everywhere you need to display a cost value with a currency symbol and 2 decimals.
 * @param value A cost value to be displayed with a currency symbol and 2 decimals.
 * @returns
 */
const Amount: React.FC<{ value: number | string | null | undefined, currencySymbol?: string }> = ({
  currencySymbol,
  value,
}) => {
  const parsedAmount = typeof value === 'string' ? parseFloat(value) : Number(value)
  return (
    <span>{`${currencySymbol ?? '$'} ${numberLib.formatTo2Decimals(parsedAmount)}`}</span>
  )
}

export default Amount
